<template>
    <div>
        <b-field :type="inputClass">
            <b-slider
                v-model="answer"
                type="is-info"
                size="is-large"
                :step="10"
                :min="parseInt(question.intMin)"
                :max="parseInt(question.intMax)"
                :custom-formatter="value => `£${value}`"
                @change="onInput()"
            >
            </b-slider>
        </b-field>

        <div
            v-if="answer"
            class="box mb-2"
        >
            <h5 class="title is-5">
                &pound;{{ answer | currency }}
            </h5>
        </div>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, decimal } from 'vuelidate/lib/validators';

export default {
    mixins: [
        validationMixin,
    ],

    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            answer: parseInt(this.question.intMin),
        };
    },

    computed: {
        isValidationError: function () {
            return this.$v.$invalid;
        },
        inputClass: function () {
            return (this.answer.length && this.isValidationError ? 'is-danger' : '');
        },
    },

    mounted() {
        this.$emit('input', this.answer);
    },

    validations() {
        return {
            answer: {
                required,
                decimal,
            },
        };
    },

    methods: {
        onInput() {
            // emit event to update parent data, if there are no validation errors
            if(this.isValidationError) {
                this.$emit('input', '');
            } else {
                this.$emit('input', this.answer);
            }
        },
    },
};
</script>
